import React from "react";
import { useSelector } from "react-redux";
import { Input, File, ColorPicker } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";
import {
  getSelfServiceBackgroundImageSelector,
  getSelfServiceDarkModeSelector,
} from "../../../../../../store/selfServiceSlice";
import { useHandlers } from "./hooks";
import "./index.scss";

/**
 * @desc Input background image URL for convention form.
 */
export const InputBackgroundImageURL = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-background-image-url-error",
  };

  const inputProps = {
    type: "text",
    id: "input-background-image-url",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "BACKGROUND URL",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.BACKGROUND_IMAGE,
  };

  return <Input {...parentProps} />;
};

/**
 * @desc Input color for convention form.
 */
export const ColorBackground = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "color-background-error",
  };

  const inputProps = {
    type: "text",
    id: "color-background",
    className: "form-control",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "BACKGROUND COLOR",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.BACKGROUND_COLOR,
  };

  return <ColorPicker {...parentProps} />;
};

/**
 * @desc Input file background image for convention form.
 */
export const FileBackgroundImage = (props) => {
  const backgroundImageURL = useSelector(getSelfServiceBackgroundImageSelector);
  const darkMode = useSelector(getSelfServiceDarkModeSelector);
  const { handleChange } = useHandlers();

  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "file-bg-image-error",
  };

  const inputProps = {
    id: "file-bg-image",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    accept: "image/*",
    style: {},
    onClick: (e) => {
      e.target.value = null;
    },
    onChange: (e) => {
      handleChange(e);
    },
    ...props,
  };

  if (backgroundImageURL) {
    inputProps.style.background = `url(${backgroundImageURL})`;
  }

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "BACKGROUND IMAGE",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
  };

  return (
    <div className={`file-background-image ${darkMode ? "dark-mode" : ""}`}>
      <ColorBackground />
      <File {...parentProps} />
      <InputBackgroundImageURL />
    </div>
  );
};
